// extracted by mini-css-extract-plugin
export default {"ingroup":"ingroup_ingroup__UbUUs","sep":"ingroup_sep__FPyFr"};